"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconDocument', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M3 2C3 1.44771 3.44771 1 4 1L10 1C10.2652 1 10.5196 1.10536 10.7071 1.29289L12.7071 3.29289C12.8946 3.48043 13 3.73478 13 4L13 14C13 14.5523 12.5523 15 12 15L4 15C3.44772 15 3 14.5523 3 14L3 2ZM6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13H10C10.5523 13 11 12.5523 11 12C11 11.4477 10.5523 11 10 11H6ZM5 8C5 7.44772 5.44772 7 6 7L10 7C10.5523 7 11 7.44772 11 8C11 8.55228 10.5523 9 10 9H6C5.44772 9 5 8.55229 5 8ZM6 3C5.44772 3 5 3.44771 5 4C5 4.55229 5.44772 5 6 5H8C8.55229 5 9 4.55228 9 4C9 3.44772 8.55228 3 8 3L6 3Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M4.00009 1L12.0001 1C12.2653 1 12.5197 1.10536 12.7072 1.29289L16.7072 5.29289C16.8947 5.48043 17.0001 5.73479 17.0001 6L17.0001 18C17.0001 18.5523 16.5524 19 16.0001 19H4.00009C3.44781 19 3.00009 18.5523 3.00009 18L3.00009 2C3.00009 1.44772 3.44781 1 4.00009 1ZM7.00009 14C6.44781 14 6.00009 14.4477 6.00009 15C6.00009 15.5523 6.44781 16 7.00009 16L13.0001 16C13.5524 16 14.0001 15.5523 14.0001 15C14.0001 14.4477 13.5524 14 13.0001 14H7.00009ZM6.00009 10C6.00009 9.44772 6.44781 9 7.00009 9H13.0001C13.5524 9 14.0001 9.44772 14.0001 10C14.0001 10.5523 13.5524 11 13.0001 11H7.00009C6.44781 11 6.00009 10.5523 6.00009 10ZM7.00009 4C6.44781 4 6.00009 4.44772 6.00009 5C6.00009 5.55229 6.44781 6 7.00009 6L10.0001 6C10.5524 6 11.0001 5.55229 11.0001 5C11.0001 4.44772 10.5524 4 10.0001 4L7.00009 4Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M4.29289 1.29289C4.48043 1.10536 4.73478 1 5 1L15 1C15.2652 1 15.5196 1.10535 15.7071 1.29289L19.7072 5.29289C19.8947 5.48042 20.0001 5.73478 20.0001 6V22C20.0001 22.5523 19.5524 23 19.0001 23L5.00008 23C4.4478 23 4.00008 22.5523 4.00008 22L4 2C4 1.73479 4.10536 1.48043 4.29289 1.29289ZM9 17C8.44772 17 8 17.4477 8 18C8 18.5523 8.44772 19 9 19H15C15.5523 19 16 18.5523 16 18C16 17.4477 15.5523 17 15 17H9ZM8 12C8 11.4477 8.44772 11 9 11L15 11C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H9C8.44772 13 8 12.5523 8 12ZM9 5C8.44772 5 8 5.44772 8 6C8 6.55229 8.44772 7 9 7H12C12.5523 7 13 6.55229 13 6C13 5.44772 12.5523 5 12 5L9 5Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M5 2.5C5 1.67157 5.67157 1 6.5 1L19.5 1C19.8978 1 20.2794 1.15804 20.5607 1.43934L26.5607 7.43934C26.842 7.72064 27 8.10217 27 8.5L27 29.5C27 30.3279 26.3292 30.9993 25.5012 31L6.50123 31.0156C6.1032 31.016 5.72135 30.8581 5.43978 30.5767C5.1582 30.2954 5 29.9137 5 29.5156L5 2.5ZM11.5 22.5C10.6716 22.5 10 23.1716 10 24C10 24.8284 10.6716 25.5 11.5 25.5H20.5C21.3284 25.5 22 24.8284 22 24C22 23.1716 21.3284 22.5 20.5 22.5H11.5ZM10 16C10 15.1716 10.6716 14.5 11.5 14.5L20.5 14.5C21.3284 14.5 22 15.1716 22 16C22 16.8284 21.3284 17.5 20.5 17.5L11.5 17.5C10.6716 17.5 10 16.8284 10 16ZM11.5 6.5C10.6716 6.5 10 7.17157 10 8C10 8.82843 10.6716 9.5 11.5 9.5L16 9.5C16.8284 9.5 17.5 8.82843 17.5 8C17.5 7.17157 16.8284 6.5 16 6.5L11.5 6.5Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;